import axios from "../libs/axios";
import authHeader from "./auth-header";

const API_URL = `${process.env.VUE_APP_API_ENDPOINT}/v1/mansion/`;

class MansionService {
  getAll() {
    return axios.get(`${process.env.VUE_APP_API_ENDPOINT}/v1/mansions/`, {
      headers: authHeader(),
    });
  }

  findById(id) {
    return axios.get(API_URL + id, {
      headers: authHeader(),
    });
  }
}

export default new MansionService();
